import { Button, Form, Space, Table } from "antd"
import { useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import { URL_BACKEND } from "../../api/url"
import { extencionImagen, sortDirections } from "../../data/datos"
import { elToast } from "../../functions/alertas"
import { useTabla } from "../../functions/useTabla"

export const usePreguntasMaterias = ( mostrarBtn = true ) => {

    // variables
    const { id } = useParams()
    const [form] = Form.useForm()

    const [visible, setVisible] = useState(false)
    const [img, setImg] = useState(null)
    const [pregunta, setPregunta] = useState()
    const [extencion, setExtencion] = useState('')
    const [respuestas, setRespuestas] = useState([
        { respuesta: 1, valor: '' },
        { respuesta: 2, valor: '' },
        { respuesta: 3, valor: '' },
        { respuesta: 4, valor: '' },
        { respuesta: 5, valor: '' }
    ])
    const [correcto, setCorrecto] = useState('')
    const [preguntasDeMateria, setPreguntasDeMateria] = useState([])
    const { getColumnSearchProps } = useTabla()
    const [activeExpRow, setActiveExpRow] = useState()
    const [respuestasPregunta, setRespuestasPregunta] = useState([])
    const [isLoading, setIsLoading] = useState( false )
    const [loading, setLoading] = useState( true )

    // modal
    const [ visibleModal, setVisibleModal ] = useState( false )
    const [loadingModal, setLoadingModal] = useState( false )
    const [materiaSeleccionada, setMateriaSeleccionada] = useState( null )

    // actualizar
    const [pkPreguntaSeleccionada, setPkPreguntaSeleccionada] = useState( null )
    const [funcion, setFuncion] = useState( null )

    // funciones
    const administrarRespuestas = (ask, valor) => {

        let r = respuestas.filter(function(dato){
            // eslint-disable-next-line
            if( dato.respuesta == ask ){
              dato.valor = valor;
            }
            return dato;
        });
        setRespuestas( r )
    }

    const onChange = e => {
        // const archivos = $seleccionArchivos.files;

        if ( e.target.value ) {

            const archivo = e.target.files[0]

            var nombreDividido = archivo.name.split(".")
            var tipo = nombreDividido[ nombreDividido.length-1 ]
            tipo = tipo.toLowerCase()

            if ( extencionImagen.includes( tipo ) ) {

                let reader = new FileReader()
                reader.readAsDataURL(archivo)
                reader.onload = (f) => setImg(f.target.result)
                setExtencion( tipo )
                const objectURL = URL.createObjectURL( archivo );
                document.querySelector( '#imgPrueba' ).src = objectURL

            } else {
                setImg( null )
                alert("Sólo se permiten imágenes")
            }
        }

    }

    const borrarImagen = () => {
        // document.querySelector( '#textareaPregunta' ).value = ''
        document.querySelector( '#imgPrueba' ).src = ''
        document.querySelector( '#inputFile' ).value = ''
        setImg( null )
        setExtencion('')
        // setPregunta('')
    }

    const guardarPregunta = () => {

        if ( !pregunta?.trim().length > 0 ) {
            elToast('La pregunta no puede quedar vacía', 'error')
            return
        }

        var imagen = ( img ) ? img : false

        let formData = new FormData();
        formData.append('funcion', 'guardarPregunta');
        formData.append('pregunta', pregunta);
        formData.append('imagen', imagen);
        formData.append('extencion', extencion);
        formData.append('fk_materia', id);
        formData.append('correcto', correcto);
        formData.append('respuesta1', respuestas[0].valor);
        formData.append('respuesta2', respuestas[1].valor);
        formData.append('respuesta3', respuestas[2].valor);
        formData.append('respuesta4', respuestas[3].valor);
        formData.append('respuesta5', respuestas[4].valor);

        setIsLoading( true )

        fetch( URL_BACKEND, {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(function (d) {

            setIsLoading( false )
            // console.log(d);
            if (d.codigo === 1) {

                elToast( d.mensaje )
                traerPreguntas()

            } else {
                elToast(d.mensaje, 'error')
            }

        })
        .catch( () => {
            alert("Error en el servidor")
            setIsLoading( false )
        })

    }

    const traerPreguntas = () => {

        let d = new FormData()
        d.append( 'pk_materia', id )
        d.append( 'funcion', 'traerPreguntas' )

        fetch( URL_BACKEND, {
            method: 'post',
            body: d
        })
        .then( res => res.json() )
        .then( function( materiasTraidas ) {
            setPreguntasDeMateria( materiasTraidas )
            setLoading( false )
        })

    }

    const reordenarRespuestas = () => {

        var respuestasReordenar = new FormData()

        respuestasPregunta.map( (e, i) => {
            respuestasReordenar.append( `pk_respuestas-${i+1}`, e.pk_respuestas )
        })
        respuestasReordenar.append( 'funcion', 'reordenarRespuestas' )

        fetch( URL_BACKEND, {
            method: "post",
            body: respuestasReordenar
        })
        .then( res => res.json())
        .then( function(d) {
            // console.log(d);
            if ( d.codigo === 1 ) {
                elToast( d.mensaje )
            } else {
                elToast( d.mensaje, 'error' )
            }

        })
    }

    const limpiarFormulario = () => {
        borrarImagen()
        setCorrecto( null )
        setPregunta('')
        form.setFieldsValue({
            pregunta: '',
            respuesta1: '',
            respuesta2: '',
            respuesta3: '',
            respuesta4: '',
            respuesta5: '',
        })
        setRespuestas([
            { respuesta: 1, valor: '' },
            { respuesta: 2, valor: '' },
            { respuesta: 3, valor: '' },
            { respuesta: 4, valor: '' },
            { respuesta: 5, valor: '' }
        ])
        document.querySelector('#Respuesta1').checked = false
        document.querySelector('#Respuesta2').checked = false
        document.querySelector('#Respuesta3').checked = false
        document.querySelector('#Respuesta4').checked = false
        document.querySelector('#Respuesta5').checked = false
    }

    //! no se usará
    const cargarPregunta = pregunta => {

        setFuncion( 'actualizarPregunta' )
        setVisible( true )
        setPkPreguntaSeleccionada( pregunta.pk_pregunta )
        console.log( pregunta );

        setCorrecto( null )
        setPregunta( pregunta.pregunta )
        form.setFieldsValue({
            pregunta: pregunta.pregunta,
            respuesta1: pregunta.respuestas[0]?.respuesta,
            respuesta2: pregunta.respuestas[1]?.respuesta,
            respuesta3: pregunta.respuestas[2]?.respuesta,
            respuesta4: pregunta.respuestas[3]?.respuesta,
            respuesta5: pregunta.respuestas[4]?.respuesta
        })
        setRespuestas([
            { respuesta: 1, valor: pregunta.respuestas[0]?.respuesta },
            { respuesta: 2, valor: pregunta.respuestas[1]?.respuesta },
            { respuesta: 3, valor: pregunta.respuestas[2]?.respuesta },
            { respuesta: 4, valor: pregunta.respuestas[3]?.respuesta },
            { respuesta: 5, valor: pregunta.respuestas[4]?.respuesta }
        ])

        let preguntaCorrecta = pregunta.respuestas.find( e => e.correcta == 1)

        let idRadioRespuesta = {
            A: '#Respuesta1',
            B: '#Respuesta2',
            C: '#Respuesta3',
            D: '#Respuesta4',
            E: '#Respuesta5'
        }

        let idRadioRespuestaSeleccionada = idRadioRespuesta[ preguntaCorrecta.letra ]

        setTimeout(() => {
            document.querySelector( idRadioRespuestaSeleccionada ).checked = true
        }, 1000);

    }



    // useEffect
    useEffect(() => {
        traerPreguntas()
        // eslint-disable-next-line
    }, [ ])

    // useEffect(() => {
    //     if ( respuestasPregunta.length > 0 ) {
    //         reordenarRespuestas()
    //     }
    // }, [ respuestasPregunta ])

    // la tabla
    const columns = [
        Table.EXPAND_COLUMN,
        {
            title: 'Número',
            dataIndex: 'indice',
            // ...getColumnSearchProps('indice'),
            sorter: (a, b) => a.indice - b.indice,
            sortDirections,
            render: (t) => <p style={{ fontSize: 14, whiteSpace: 'pre-line' }}>{ t }</p>
        },
        {
            title: 'Pregunta',
            dataIndex: 'pregunta',
            ...getColumnSearchProps('pregunta'),
            sorter: (a, b) => a.pregunta.localeCompare(b.pregunta),
            sortDirections,
            render: (t) => <p style={{ fontSize: 14, whiteSpace: 'pre-line' }}>{ t }</p>
        },
        {
            title: 'Acciones',
            render: (text, record) => {

                if ( mostrarBtn ) return (
                    <Space size="middle">
                        <Link to={`/materias/${id}/editar_pregunta/${record.pk_preguntas}-${record.indice}`}>
                            Editar
                        </Link>
                    </Space>
                )
            },
        },
    ]

    return {
        visible,
        setVisible,
        onChange,
        borrarImagen,
        setPregunta,
        guardarPregunta,
        setCorrecto,
        administrarRespuestas,
        preguntasDeMateria,
        columns,
        activeExpRow,
        setActiveExpRow,
        respuestasPregunta,
        setRespuestasPregunta,
        reordenarRespuestas,
        visibleModal,
        setVisibleModal,
        loadingModal,
        setMateriaSeleccionada,
        limpiarFormulario,
        form,
        setFuncion,
        isLoading,
        loading
    }
}
